import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import './ThirdSectionFeatured.scss';
import phoneImage1 from '../../../assets/Images/playlist phone graphic.png'; // Replace with actual image paths
import phoneImage2 from '../../../assets/Images/playlist phone graphic 2.png';
import phoneImage3 from '../../../assets/Images/playlist phone graphic 3.png';
import UnifiedButton from '../../shared/Button';
import { useNavigate } from 'react-router-dom';

const ThirdSectionFeatured = () => {

    const navigate = useNavigate()

    const handleplaylistformClick = () => {
        console.log('Navigating to /pricing');
        navigate('/support/legal-forms/2');
        window.scrollTo(0, 0);
    };

    return (
        <Box className="third-section-featured">
            <Box className="text-content">
                <Typography variant="h4" className="title">
                    Get your music heard on Spotify
                </Typography>
                <Typography variant="h2" className="highlight">
                    with FM Digital Official.
                </Typography>
                <Typography variant="body1" className="description">
                    We love featuring emerging FM Digital Official artists on our playlists! As an Official Spotify Tastemaker, our playlists are at the forefront of new music discovery.
                </Typography>
                <Typography variant="body1" className="description">
                    Submitting your latest track is simple. Just tell us about yourself and your music, and choose which of our playlists you'd like to submit to. We listen to every submission so click the button below to get started.
                </Typography>

                <UnifiedButton onClick={handleplaylistformClick} textContent={"Submit your song now"} className="cta-button" />


            </Box>

            <Box className="images">
                <img src={phoneImage1} alt="Phone 1" className="phone-image" />
                <img src={phoneImage2} alt="Phone 2" className="phone-image" />
                <img src={phoneImage3} alt="Phone 3" className="phone-image" />
            </Box>
        </Box>
    );
};

export default ThirdSectionFeatured;